var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksSuggestionShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5544 5.24211H19.5119C16.7958 5.24211 14.1645 4.10526 12.3183 2.12632C12.1485 1.95789 11.8302 1.95789 11.6817 2.12632C9.83554 4.10526 7.20424 5.24211 4.48806 5.24211H4.44562C4.2122 5.24211 4 5.43158 4 5.68421V10.4632C4 14.4 5.97347 18.0632 9.2626 20.2526L11.7454 21.9158C11.809 21.9579 11.8939 22 12 22C12.1061 22 12.1698 21.9789 12.2546 21.9158L14.7374 20.2526C18.0265 18.0632 20 14.4 20 10.4632V5.66316C19.9788 5.43158 19.7878 5.24211 19.5544 5.24211Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksSuggestionShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_suggestion_shield.b6c3f82892c5e87cdbd4333d991f5f2d.svg";